import styled from 'styled-components';

export const MobileSliderContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
  overflow-y: hidden;

  scrollbar-width: none;
  &&::-webkit-scrollbar {
    display: none;
  }

  .image {
    margin-right: 3px;
    &.full {
      margin-right: 0;
      img {
        width: 100%;
      }
    }
  }
`;
